export var Role;
(function (Role) {
    Role["Guest"] = "guest";
    Role["BusinessOwner"] = "client";
    Role["BusinessEmployee"] = "employee";
    Role["Admin"] = "admin";
    Role["Rightholder"] = "copyright_holder";
    Role["MusicEditor"] = "music_editor";
})(Role || (Role = {}));
